import Terms from '../terms/terms';
import ArtworkRequirements from '../artwork-requirements/artwork-requirements'
import { POP as pop } from '@/http-common';

export default {
    name: 'basket',
    components: { Terms, ArtworkRequirements },
    data() {
        return {
            complete: false,
            loading: true,
            sending: false,
            terms: false,
            assetUploads: 0,
            error: { show: false, message: '' },
            price_error: { show: false, message: null },
            order: { ref: '', ref_name: '', studio_instructions: '', design: '', basket: { items: [], design_fee: 0 } }
        }
    },
    computed: {
        canConfirm() {
            return this.terms && this.order.ref_name.length > 0 && this.order.basket.items.length > 0 && this.valid
        },
        spec() {
            return this.$root.$data.spec;
        },
        price() {
            if (this.order.basket.items.length == 0) return 0;
            let final = 0;
            this.order.basket.items.forEach((item) => {
                final += item.price
            })
            return final
        },
        vat() {
            return this.price == 0 ? 0 : this.price * 0.2;
        },
        valid() {
            let isValid = true
            for (var i = 0; i < this.order.basket.items.length; i++) {
                let item = this.order.basket.items[i]
                if (!item.send_later) {
                    isValid = item.asset != null
                    if (!isValid) break
                }
            }
            return isValid
        }
    },
    methods: {
        fetch() {
            this.axios.get('/api/basket').then((response) => {
                this.order.basket = response.data
                this.order.basket.design_fee = 0
                this.transformBasketData()
                this.loading = false
            }).catch((error) => {
                console.log(error)
                this.loading = false
            })
        },
        transformBasketData() {
            this.order.basket.items.forEach((item) => {
                this.$set(item, 'send_later', true)
                this.$set(item, 'asset', null)
            })
        },
        remove(item) {
            this.loading = true
            this.order.basket.items.splice(this.order.basket.items.indexOf(item), 1);
            this.axios.post('/api/basket/remove', {
                id: item.id
            }).then((response) => {
                this.loading = false
                // this.fetch()
            }).catch((error) => {
                this.loading = false
                this.fetch()
            })
        },
        update: _.debounce(function (item) {
            this.loading = true
            this.axios.patch('/api/basket/update', {
                id: item.id, quantity: item.quantity
            }).then((response) => {
                let updated = response.data.item;
                this.$set(item, 'price', updated.price)
                this.$set(item, 'quantity', updated.quantity)
                this.price_error = { show: false, message: null }
                this.loading = false
            }).catch((error) => {
                this.price_error = { show: true, message: error.response.data.pop.message }
                this.loading = false
            })
        }, 500),
        confirm() {
            this.loading = true
            this.sending = true
            let items = {};
            this.order.basket.items.forEach(item => {
                items[item.id] = item;
            })
            this.axios.post('/api/basket/order', {
                'ref_name': this.order.ref_name,
                'studio_instructions': this.order.studio_instructions,
                'chosen_design': this.order.design,
                'sub_total': this.price,
                'total': this.price + this.vat,
            }).then((response) => {
                this.order.ref = response.data.ref;
                response.data.items.forEach(item => {
                    this.assetUploads++;
                    let fd = new FormData()
                    fd.append('assetFile', items[item.id].asset)
                    console.log('uploading asset..', item.line, item.id);
                    pop.post('/asset/upload/' + item.line, fd).then(response => {
                        this.assetUploads--;
                    }).catch(e => {
                        console.log(e)
                        this.complete = true
                        this.loading = false
                        this.sending = false
                    });
                })
                if (this.assetUploads == 0) {
                    this.complete = true
                    this.loading = false
                    this.sending = false
                }
            }).catch((error) => {
                console.log(error)
                this.loading = false
                this.sending = false
                this.error = { show: true, message: "We've been unable to complete your order at this time, try again later." }
            })
        },
        getItemQuantities(item) {
            pop.get('price', {
                params: { specificationId: item.specification_id, itemId: item.product.direct_mail_item_id, quantity: item.quantity }
            }).then((response) => {
                console.log('pop-price', response)
                if (response.data.error) return
                this.$set(item, 'min_quantity', response.data.results.minimumQuantity)
                this.$set(item, 'max_quantity', response.data.results.maximumQuantity)
            }).catch((error) => {
                console.log('pop-price', error)
            })
        },
        closeModal(ref) {
            this.$root.$emit('bv::hide::modal', ref)
        },
        designSelected(design) {
            // console.log('design', design)
            this.order.design = design.image
        }
    },
    created() {
        this.$root.$on('design::selected', this.designSelected)
    },
    beforeDestroy() {
        this.$root.$off('design::selected', this.designSelected)
    },
    mounted() {
        this.fetch();
    },
    watch: {
        assetUploads: function (uploads) {
            if (uploads <= 0) {
                this.complete = true
                this.loading = false
                this.sending = false
                this.assetUploads = 0
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/basket/basket.js